<script lang="ts">
    import {
        ERROR__error,
        SPEECH__tryAgain,
    } from "@app/services/i18n.messages";
    import { dictionary } from "@app/services/currentDictionary.service";
    import { getMessage } from "@app/services/i18n.service";
    import Loading from "../Icons/Loading.svelte";
    import { memorizeAutomaticTranslationResult, type AutomaticTranslationForDictionaryAndPhraseProvider, type AutomaticTranslationResult } from "./AutomaticTranslation.service";

    export let loadTranslation: AutomaticTranslationForDictionaryAndPhraseProvider;

    export let containerElement: HTMLElement;
    let resultsPromise = loadTranslation();
    let showLoading = false;

    function clearLoadingIndicator() {
        containerElement
            .querySelectorAll(".loading-indicator")
            .forEach((el) => el.parentNode.removeChild(el));
    }

    function tryAgain() {
        resultsPromise = loadTranslation();
        showLoading = true;
    }
    $: {
        resultsPromise = resultsPromise.finally(clearLoadingIndicator);
        resultsPromise.catch(console.error)

        resultsPromise.then((result) => {
            memorizeAutomaticTranslationResult(result);
        })
    }
</script>

{#await resultsPromise}
    {#if showLoading}<Loading class="w-6 h-6" />{/if}
{:then result}
    <span class:dense={$dictionary.l2.dense}>
        {@html result.result.html}
    </span>
{:catch}
    <div>
        <span class="text-secondary-700 text-sm">
            {getMessage(ERROR__error)}
        </span>
        <button on:click={tryAgain} class="mx-2 button-xs">
            {getMessage(SPEECH__tryAgain)}
        </button>
    </div>
{/await}
